import React from 'react';
import PropTypes from 'prop-types'
import $ from 'jquery';
import _debounce from 'lodash/debounce';
import AppStore from '../stores/AppStore';
import AppActions from '../actions/AppActions';
import TemplateData from '../utility/getTemplateData';
import SingleAmount from '../components/amount/SingleAmount';
import Calculator from '../components/amount/calculator';
import PresetAmountRow from './amount/PresetAmountRow';
import {
	isAmountGreaterThanZero
} from './amount/amountUtils';

class AmountWrapper extends React.Component {
	constructor(props) {
		super(props);

		const currencyObj = JSON.parse(document.getElementById('currencyLists').innerHTML || {});
		const { currencies: currencyLists, symbols: currencySymbols } = currencyObj || {};

		let userCountry = TemplateData.donorIpCountry;
		let availableCurrencies = currencyLists[userCountry] || currencyLists.US;
		let userAmountCode = availableCurrencies[0];
		let charityAmountCode = AppStore.getDonationCode();
		let isEditable = !!TemplateData.donationAmountEditable;
		// let showCBCalculator = TemplateData.pxp && TemplateData.pxp.calculator && TemplateData.pxp.calculator.experiment || false;

		let isCalculator = false;
		// Disabled Calculator
		// let isCalculator =
		// 	isEditable &&
		// 	userAmountCode !== charityAmountCode &&
		// 	(showCBCalculator || TemplateData.isCorpIp);

		this.state = {
			charityAmountCode,
			charityAmount: AppStore.getDonationAmount() || '',
			charityAmountSymbol: AppStore.getDonationSymbol(),
			charityDisabled: false,

			userCountry,
			userAmountCode,
			userAmount: '',
			userDisabled: false,

			availableCurrencies,
			currencySymbols,
			isCalculator,
			decimalPoint: TemplateData.donationDecimalPoint || '.',
			conversionRate: '',
			isAmountEditable: isEditable,

			showValidationError: props.showValidationError || false,
			validationErrorMessage: props.validationErrorMessage || ''
		};
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (this.state.showValidationError !== nextProps.showValidationError) {
			this.setState({
				showValidationError: nextProps.showValidationError,
				validationErrorMessage: nextProps.validationErrorMessage
			});
		}
	}

	normalizeAmount = (amount) => {
		return isNaN(amount) ? 0 : amount;
	}

	setAppAmount = (amount) => {
		AppActions.changeAmount({
			amount
		});
	}

	getConversionRate = (state, exchangeRate) => {
		let rate = exchangeRate.base_currency_code === state.userAmountCode ?
			exchangeRate.quote_amount : 1 / exchangeRate.quote_amount;
		return rate.toFixed(2);
	}

	getConversionRequest = (state, params, callback) => {
		this.getConversionRequest = _debounce((st, par, fn) => {
			const queryParams = {
				fromCountry: st.userCountry,
				fromCurrency: st.userAmountCode,
				toCurrency: st.charityAmountCode,
				...par
			};

			if (queryParams.fromAmount) {
				queryParams.fromAmount = this.normalizeAmount(queryParams.fromAmount);
			} else {
				queryParams.toAmount = this.normalizeAmount(queryParams.toAmount);
			}

			const url = '/donate/calculate-foreign-exchange';
			this.props.conversionStatus(true);
			Promise.resolve($.post(url, queryParams)).then(({ result }) => {
				this.props.conversionStatus(false);
				fn(result);
			}).catch(() => {
				this.props.conversionStatus(false);
				let amount = queryParams.fromAmount || queryParams.toAmount || '';
				amount += '';
				fn({
					target: { value: amount },
					source: { value: amount },
					exchange_rate: {
						base_currency_code: queryParams.userAmountCode,
						quote_amount: 1
					}
				});
			});
		}, 500);

		this.getConversionRequest(state, params, callback);
	}

	/*
	* getConversion
	* Getting conversion rate for calculator
	*/
	getConversion = (state, params, fn) => {
		// Conversion is only required for calculator
		if (state.isCalculator) {
			this.getConversionRequest(state, params, fn);
		} else {
			const amount = params.fromAmount || params.toAmount || '';
			fn({
				target: { value: amount },
				source: { value: amount },
				exchange_rate: {
					base_currency_code: state.userAmountCode,
					quote_amount: 1
				}
			});
		}
	}

	handleAmountChange = (amount) => {
		this.setState({ charityAmount: amount });
		this.setAppAmount(amount);

		let recurringStatus = AppStore.getDonationRecurring() === 'checked';
		if (recurringStatus) {
			if (isAmountGreaterThanZero(amount)) {
				$('#donateNowAmt').html(this.state.charityAmountSymbol + amount);
			} else {
				$('#donateNowAmt').html(' ');
			}
		}
	}

	handleAmountFocus() {
		this.props.onFocus();
	}

	handleUserAmountChange = (amount) => {
		let snapshot = {
			userAmount: amount,
			charityDisabled: true
		};
		let state = { ...this.state, ...snapshot };
		this.setState(snapshot);

		this.getConversion(state, {
			fromAmount: state.userAmount
		}, ({ target, exchange_rate }) => {
			this.setState({
				conversionRate: this.getConversionRate(state, exchange_rate),
				charityAmount: target.value,
				charityDisabled: false
			});
			this.setAppAmount(target.value);
		});
	}

	handleUserCurrencyChange = (currencyCode) => {
		let snapshot = {
			userAmountCode: currencyCode,
			charityDisabled: true
		};
		let state = { ...this.state, ...snapshot };
		this.setState(snapshot);

		this.getConversion(state, {
			fromAmount: state.userAmount
		}, ({ target, exchange_rate }) => {
			state.charityAmount = target.value;
			this.setState({
				conversionRate: this.getConversionRate(state, exchange_rate),
				charityAmount: state.charityAmount,
				charityDisabled: false
			});
			this.setAppAmount(target.value);
		});
	}

	handleCharityAmountChange = (amount) => {
		let snapshot = {
			charityAmount: amount,
			userDisabled: true
		};
		let state = { ...this.state, ...snapshot };
		this.setState(snapshot);

		this.getConversion(state, {
			toAmount: state.charityAmount
		}, ({ source, exchange_rate }) => {
			this.setState({
				conversionRate: this.getConversionRate(state, exchange_rate),
				userAmount: source.value,
				userDisabled: false
			});
			this.setAppAmount(state.charityAmount);
		});
	}

	shouldShowPresetAmounts = () => {
		return TemplateData.enablePresetAmounts && !this.state.isCalculator;
	}

	renderPresetAmounts = () => {
		return <PresetAmountRow
			charityAmount={this.state.charityAmount}
			charityAmountSymbol={this.state.charityAmountSymbol}
			charityAmountCode={this.state.charityAmountCode}
			decimalPoint={this.state.decimalPoint}
			isAmountEditable={this.state.isAmountEditable}
			handleAmountChange={this.handleAmountChange.bind(this)}
			handleAmountFocus={this.handleAmountFocus.bind(this)}
			hideValidationError={this.props.hideValidationError}
			showValidationError={this.state.showValidationError}
			validateDonationAmount={this.props.validateDonationAmount}
			validationErrorMessage={this.state.validationErrorMessage}
		/>
	}

	render() {
		if (this.shouldShowPresetAmounts()) {
			return (
				<div className="amount-wrapper">
					{this.renderPresetAmounts()}
				</div>
			)
		}

		return (<div className="amount-wrapper">
			{this.state.isCalculator ?
				<Calculator
					availableCurrencies={this.state.availableCurrencies}
					charityAmountSymbol={this.state.charityAmountSymbol}
					currencySymbols={this.state.currencySymbols}
					decimalPoint={this.state.decimalPoint}
					conversionRate={this.state.conversionRate}
					fromAmount={this.state.userAmount}
					fromCode={this.state.userAmountCode}
					fromDisabled={this.state.userDisabled}
					toAmount={this.state.charityAmount}
					toCode={this.state.charityAmountCode}
					toDisabled={this.state.charityDisabled}
					handleFromChange={this.handleUserAmountChange.bind(this)}
					handleFromCurrencyChange={this.handleUserCurrencyChange.bind(this)}
					handleToChange={this.handleCharityAmountChange.bind(this)}
					toError={this.state.showValidationError}
					toErrorMessage={this.state.validationErrorMessage}
					handleAmountFocus={this.handleAmountFocus.bind(this)}
				/> :
				<SingleAmount
					amount={this.state.charityAmount}
					symbol={this.state.charityAmountSymbol}
					code={this.state.charityAmountCode}
					decimalPoint={this.state.decimalPoint}
					isEditable={this.state.isAmountEditable}
					handleAmount={this.handleAmountChange.bind(this)}
					handleAmountFocus={this.handleAmountFocus.bind(this)}
					showValidationError={this.state.showValidationError}
					validationErrorMessage={this.state.validationErrorMessage}
				/>
			}
		</div>);
	}
}

AmountWrapper.propTypes = {
	conversionStatus: PropTypes.func,
	showValidationError: PropTypes.bool,
	hideValidationError: PropTypes.func,
	validationErrorMessage: PropTypes.string,
	validateDonationAmount: PropTypes.func,
	onFocus: PropTypes.func
};

export default AmountWrapper;



// WEBPACK FOOTER //
// ./components/amountWrapper.js